const GOLD_STRONG = 'rgba(200,146,42,.14)'
const GOLD_SOFT = 'rgba(200,146,42,.10)'
const WHITE_SOFT = 'rgba(255,255,255,.10)'

function Bar({ className = '', strong = false }) {
  return <div className={`rounded ${className}`} style={{ background: strong ? GOLD_STRONG : GOLD_SOFT }} />
}

function HeroBar({ className = '' }) {
  return <div className={`rounded ${className}`} style={{ background: WHITE_SOFT }} />
}

export default function BookingPageSkeleton() {
  return (
    <div className="animate-pulse">
      {/* Hero band */}
      <div className="relative overflow-hidden bg-primary pt-28 pb-16">
        <div aria-hidden="true" className="absolute inset-0 bg-linear-to-b from-[#3a0a14] via-primary to-[#2a0710]" />
        <div className="container px-6 mx-auto relative z-10">
          <HeroBar className="h-3 w-56 mb-7" />
          <div className="flex flex-wrap items-end justify-between gap-8">
            <div className="max-w-xl space-y-4">
              <HeroBar className="h-7 w-36 !rounded-full" />
              <HeroBar className="h-11 w-80 max-w-full" />
              <HeroBar className="h-3 w-64 max-w-full" />
            </div>
            <div className="flex items-center gap-3 rounded-2xl px-4 py-3" style={{ background: WHITE_SOFT }}>
              <div className="w-11 h-11 rounded-full" style={{ background: 'rgba(255,255,255,.16)' }} />
              <div className="space-y-2">
                <HeroBar className="h-3 w-28" />
                <HeroBar className="h-2.5 w-20" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="container px-6 mx-auto mt-10 pb-20">
        {/* Stepper */}
        <div className="flex items-center gap-3 sm:gap-4 mb-10">
          <div className="flex items-center gap-2.5">
            <div className="h-8 w-8 rounded-full" style={{ background: GOLD_STRONG }} />
            <Bar className="h-3 w-32" strong />
          </div>
          <div className="h-px flex-1 max-w-20" style={{ background: GOLD_SOFT }} />
          <div className="flex items-center gap-2.5">
            <div className="h-8 w-8 rounded-full" style={{ background: GOLD_SOFT }} />
            <Bar className="h-3 w-24" />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7 space-y-8">
            {/* Schedule calendar */}
            <div className="info-card p-6 sm:p-8 space-y-6">
              <Bar className="h-5 w-48" strong />
              <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
                {Array.from({ length: 5 }, (_, i) => (
                  <div key={i} className="rounded-2xl h-20" style={{ background: GOLD_SOFT }} />
                ))}
              </div>
              <Bar className="h-4 w-36" />
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                {Array.from({ length: 8 }, (_, i) => (
                  <Bar key={i} className="h-11 !rounded-xl" />
                ))}
              </div>
            </div>

            {/* Birth details form */}
            <div className="info-card p-6 sm:p-8 space-y-5">
              <Bar className="h-5 w-56" strong />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {Array.from({ length: 4 }, (_, i) => (
                  <div key={i} className="space-y-2">
                    <Bar className="h-3 w-24" />
                    <Bar className="h-11 w-full !rounded-xl" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Summary sidebar */}
          <aside className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="info-card p-6 space-y-5">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-2xl shrink-0" style={{ background: GOLD_STRONG }} />
                <div className="space-y-2 flex-1">
                  <Bar className="h-4 w-2/3" strong />
                  <Bar className="h-3 w-1/2" />
                </div>
              </div>
              <div className="space-y-2.5 pt-2">
                <Bar className="h-3 w-full" />
                <Bar className="h-3 w-11/12" />
                <Bar className="h-3 w-4/5" />
              </div>
              <Bar className="h-12 w-full !rounded-2xl" />
              <Bar className="h-12 w-full !rounded-2xl" />
              <Bar className="h-12 w-full !rounded-full" strong />
            </div>
          </aside>
        </div>
      </section>
    </div>
  )
}
